module.exports = __webpack_public_path__ + "media/images/games/league-of-legends/logo-0970a3abcb13c0b4fa5ddc7e446fa90e.png";